import styles from './GestorList.module.scss'
import { useNavigate } from 'react-router-dom';
import api from '../../services/api'
import { useState, useEffect } from 'react';
import { AiOutlineLoading3Quarters } from 'react-icons/ai';
import { BiShoppingBag } from "react-icons/bi";
import { clearVendaSelecionada, setVendaSelecionada, getUserId } from '../../services/gestor';

function GestorList() {
  const [loading, setLoading] = useState(true);
  const [items, setItems] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    // volta para a lista = nenhuma venda selecionada
    clearVendaSelecionada();
    api.post('/shoppinglist', { idpessoa: getUserId() })
    .then(res => {
      if(res.data.sucesso || Array.isArray(res.data.retorno)) {
        setItems(res.data.retorno);
      }
    }).catch(err => {
      console.log(err);
    }).finally(() => {
      setLoading(false);
    })
  }, [])

  function openVenda(id) {
    setVendaSelecionada(id);
    navigate('/');
  }

  return (
    <>
    { loading ? <div className={styles.loading}><AiOutlineLoading3Quarters/></div> :
    <div className={styles.container}>
      <div className={styles.headerList}>
        <h2><BiShoppingBag/> Vendas</h2>
      </div>
      <div className={styles.list}>
        {items.length === 0 ? <span className={styles.grey}>Nenhuma venda encontrada.</span> : ''}
        {items.map(item => (
          <div key={item.id} className={styles.listItem} onClick={() => openVenda(item.id)}>
            <span className={styles.grey}>{item.nome}</span>
            <button><BiShoppingBag/> Abrir venda</button>
          </div>
        ))}
      </div>
    </div>
    }
    </>
  );
}

export default GestorList;
